<template>
  <BlogPostList :page="page" />
</template>

<script>
export default {
  name: "PageNumber",
  computed: {
    page() {
      const pageNumber = parseInt(this.$route.params.page)
      if (isNaN(pageNumber)) {
        return 1
      }
      return pageNumber
    },
  },
}
</script>
